export const EXPERIENCE_REVIEW_HEADING_TEXT = "Review experience";
export const EXPERIENCE_REVIEW_SUBTITLE_TEXT =
  "Review your experience before you confirm and book.";
